import httpClient from './httpClient';

const listadoTareasRequest = (filter) => {    
    return httpClient.post('/AppPedido/getTareasByMensajero', filter);
};

export default listadoTareasRequest;